import { useInfiniteQuery } from '@tanstack/react-query';
import { http } from '../config';
import {
  IGetTransactionsRequestPayload,
  IGetTransactionsResponse,
} from '../../types';

interface ITransactions {
  listTransactions: (
    pageParam: number,
    payload: IGetTransactionsRequestPayload
  ) => Promise<IGetTransactionsResponse>;
}
export const transactions: ITransactions = {
  listTransactions: (pageParam, payload) =>
    http.get(
      `/api/auth/customer_portal/transactions?page=${pageParam}` +
        `${payload.from ? `&from=${payload.from}` : ''}` +
        `${payload.to ? `&to=${payload.to}` : ''}` +
        `${payload.is_refunded !== undefined ? `&is_refunded=${payload.is_refunded}` : ''}` +
        `&is_successful=true`
    ),
};
export const useTransactions = (payload: IGetTransactionsRequestPayload) => {
  return useInfiniteQuery({
    queryKey: [
      'list-transactions',
      payload.from,
      payload.to,
      payload.is_refunded,
      payload.page,
    ],
    queryFn: ({ pageParam = 1 }) =>
      transactions.listTransactions(pageParam, payload),
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage?.next) return undefined;
      return allPages.length + 1;
    },

    initialPageParam: 1,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
